<script lang="ts" setup>
import Pdf from "@/components/Pdf.vue"
import VarsityInlineConfirm from "@/components/VarsityInlineConfirm.vue"
import VarsityInlineConfirmButton from "@/components/VarsityInlineConfirmButton.vue"
import VarsityInlineConfirmGroup from "@/components/VarsityInlineConfirmGroup.vue"
import { createInlineConfirm } from "@/composables/createInlineConfirm"
import type { StaffReviewGeneralTermsTask } from "@/model/staff/staff-review-general-terms-task"
import type { TasksProps } from "@/pages/Tasks/Tasks/tasks-props"
import { useHttpClient } from "@/vf"

const props = defineProps<TasksProps<StaffReviewGeneralTermsTask>>()
const emit = defineEmits<{
    (e: "updated"): void
}>()

const http = useHttpClient()

const inlineConfirmAccept = createInlineConfirm({
    async action() {
        await http.post(`/staff-member/contract/general-terms/${props.task.id}/accept`, {})
    },
    afterAction() {
        emit("updated")
    },
})

const inlineConfirmReject = createInlineConfirm({
    async action() {
        await http.post(`/staff-member/contract/general-terms/${props.task.id}/reject`, {})
    },
    afterAction() {
        emit("updated")
    },
})
</script>

<template>
    <div class="p-4">
        <div class="row">
            <div class="col-md-6">
                <div v-for="attachment in props.task.attachments" class="mt-3" :key="attachment.id">
                    <pdf :file="`/tasks/task/${props.task.id}/attachment/${attachment.id}/download`"></pdf>
                </div>
            </div>
            <template v-if="props.task.state == 'open'">
                <div v-if="props.viewMode == 'admin'" class="col-md-6 mt-4 text-right">
                    <VarsityInlineConfirmGroup>
                        <VarsityInlineConfirmButton
                            :controller="inlineConfirmAccept"
                            class="btn btn-success btn-shape-skewed"
                        >
                            {{ $t("@tasks:tasks.staff.review_accept") }}
                        </VarsityInlineConfirmButton>
                        <VarsityInlineConfirmButton
                            :controller="inlineConfirmReject"
                            class="btn btn-danger btn-shape-skewed"
                        >
                            {{ $t("@tasks:tasks.staff.review_reject") }}
                        </VarsityInlineConfirmButton>

                        <VarsityInlineConfirm :controller="inlineConfirmAccept" :spinner="true">
                            <template #confirmation>{{ $t("@tasks:tasks.staff.review_accept_confirm") }}</template>
                            <template #success>
                                {{ $t("@tasks:tasks.staff.review_accept_confirm_successful") }}
                            </template>
                        </VarsityInlineConfirm>

                        <VarsityInlineConfirm :controller="inlineConfirmReject">
                            <template #confirmation>{{ $t("@tasks:tasks.staff.review_reject_confirm") }}</template>
                            <template #success>{{ $t("@tasks:tasks.staff.review_reject_successful") }}</template>
                        </VarsityInlineConfirm>
                    </VarsityInlineConfirmGroup>
                </div>
                <div v-if="props.viewMode == 'customer'" class="col-md-6 mt-4">
                    {{ $t("@tasks:tasks.staff.review_customer_info") }}
                </div>
            </template>
        </div>
    </div>
</template>
